module.exports = __webpack_public_path__ + "static/city4-08f0a5f52b972ce7ffcf71be969a2a5b.svg";